<script>
  import { onMount, onDestroy } from "svelte"
  import { _ } from "@/i18n"
  import { mobileToolbarConfig } from "@/stores/stores"
  import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.svelte"
  import HealthRecordsHeader from "@/components/HealthRecordsHeader/HealthRecordsHeader.svelte"

  export let activeClassLabel = ""

  /**
   * Set the mobileToolbarConfig options for HR
   */
  onMount(() => {
    mobileToolbarConfig.set({
      left: { arrow: true, text: $_("HR.HEALTH_RECORDS") },
      center: { logo: false },
      customClass: "blue-bkg-sm-down",
      redirectPath: "/health-records",
    })
  })

  /**
   * Reset the mobileToolbarConfig
   */
  onDestroy(() => {
    mobileToolbarConfig.set({})
  })

  const breadcrumbLinks = [
    {
      title: $_("HR.HEALTH_RECORDS"),
      link: "/health-records",
      id: "health-records",
    },
    {
      title: $_("HR.CARE_TEAM&PATIENT_INFORMATION"),
      active: true,
    },
  ]
  const navTabs = [
    {
      href: "/health-records/care-team",
      label: $_("HR.CARE_TEAM"),
    },
    {
      href: "/health-records/patient-info",
      label: $_("HR.PATIENT_INFORMATION"),
    },
  ]
</script>

<section class="health-records-wrapper">
  <Breadcrumb {breadcrumbLinks} />
  <HealthRecordsHeader
    title={$_("HR.CARE_TEAM&PATIENT_INFORMATION")}
    {navTabs}
    {activeClassLabel}
  />
  <section
    class="health-records-container"
    class:card-full-width={activeClassLabel === $_("HR.PATIENT_INFORMATION")}
  >
    <slot />
  </section>
</section>

<style lang="scss">
  @import "../index.scss";

  @media (max-width: 575.98px) {
    .health-records-wrapper .health-records-container.card-full-width {
      padding-left: 0;
      padding-right: 0;
    }
  }
</style>
